const ellipsisString = (text: string, long: number) => {
  if (!text) {
    return "";
  }
  return text.length > long ? `${text.substring(0, long)}...` : text;
};
export default ellipsisString;
